import React from "react";
import { Card } from "components/ui/card";
import { Skeleton } from "components/ui/skeleton";

const AdCardSkeleton: React.FC = () => (
    <Card variant="skeleton">
        <div className="flex items-start justify-between gap-3">
            <div className="flex min-w-0 items-center gap-3">
                <Skeleton className="h-10 w-10 shrink-0 rounded-full" />
                <div className="flex-1 space-y-2">
                    <Skeleton className="h-4 w-32" />
                    <Skeleton className="h-3 w-24" />
                </div>
            </div>
            <Skeleton className="h-6 w-28 rounded-full" />
        </div>
        <Skeleton className="h-6 w-36 rounded-lg" />
        <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-4/5" />
            <Skeleton className="h-4 w-2/3" />
        </div>
        <Skeleton className="h-3 w-48 mt-auto" />
    </Card>
);

export default AdCardSkeleton;
